'use client';

/**
 * Retrieves the value of a client-side cookie by its name.
 *
 * @param {string} name - The name of the cookie to retrieve.
 * @return {string|undefined} The value of the cookie if it exists, otherwise undefined.
 */
export const getClientCookie = (name: string) => {
  if (typeof document !== 'undefined') {
    const cookie = document.cookie.split(';').find((c) => c.trim().startsWith(`${name}=`));
    if (!cookie) return undefined;
    return cookie.split('=')[1];
  }
};

/**
 * Sets a client-side cookie with the given name and value.
 *
 * @param {string} name - The name of the cookie to set.
 * @param {string} value - The value of the cookie to set.
 * @return {void}
 */
export const setClientCookie = (name: string, value: string, expires?: string) => {
  const secureEnv = process.env.NEXT_PUBLIC_ENV !== 'development';
  if (typeof document !== 'undefined' && value)
    document.cookie = `${name}=${value};${expires ? `expires=${expires};` : ''}path=/;${secureEnv ? 'secure;' : ''}`;
};

/**
 * Deletes one or multiple client cookies.
 *
 * @param {string} name - The name or names of the cookies to delete.
 * @return {void}
 */
export const deleteClientCookie = (names: string | string[]) => {
  if (typeof document !== 'undefined') {
    const cookies = Array.isArray(names) ? names : [names];
    cookies.forEach((cookieName) => {
      document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
    });
  }
};
